export default "__VITE_ASSET__BusciSPp__"